export const handleEmailChange = (e, setEmail, setEmailError) => {
  let valid = false;
  const el = document.getElementById(e.target.id);

  if (e.target.id === 'email') {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    valid = re.test(String(e.target.value).toLowerCase());
  }

  if (valid) {
    setEmail(e.target.value ? e.target.value.trim() : e.target.value);
    el.classList.remove('invalid');
    setEmailError(false);
  } else {
    el.classList.add('invalid');
    setEmailError(true);
  }
};

export const handleSupportEmailChange = (e, setValue) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid = e.target.value === '' || emailRegex.test(e.target.value);

  if (isValid) {
    e.target.classList.remove('invalid');
    setValue(e.target.value.trim());
  } else {
    e.target.classList.add('invalid');
  }
  return isValid;
};

export const handlePhoneChange = (e, setValue) => {
  const phoneRegex = /^\+?[0-9]*$/;
  const isValid = phoneRegex.test(e.target.value);

  if (isValid) {
    e.target.classList.remove('invalid');
    setValue(e.target.value);
  } else {
    e.target.classList.add('invalid');
  }
  return isValid;
};

export const handleEidChange = (e, setEid) => {
  let valid = false;
  const el = document.getElementById(e.target.id);

  if (e.target.id === 'erv') {
    if (e.target.value.length > 0) {
      valid = true;
    }
  }

  if (valid) {
    setEid(e.target.value ? e.target.value.trim() : e.target.value);
    el.classList.remove('invalid');
  } else {
    el.classList.add('invalid');
  }
};

export const handleNameChange = (e, setName) => {
  let valid = false;
  const el = document.getElementById(e.target.id);

  if (e.target.id === 'name') {
    if (e.target.value.length > 0) {
      valid = true;
    }
  }

  if (valid) {
    setName(e.target.value ? e.target.value.trim() : e.target.value);
    el.classList.remove('invalid');
  } else {
    el.classList.add('invalid');
  }
};
